module.exports = __webpack_public_path__ + "media/checkmarks/green-checkmark-68ab5ccd.svg";